<template>
  <el-container>
    <el-header  class="font-size-default" height="60px">
      
      <h1 class="heard_top_left">{{ user.unitName?user.unitName:'云票管理平台' }}</h1>
        <div class="heard_top_right">
          <div class="heard_top_right_li">欢迎：{{ user.nickName}}</div>
          <div class="heard_top_right_li">{{ currentDate }}</div>
          <div class="heard_top_right_li pointer" @click="logoutExec">退出</div>
          <div class="heard_top_right_box">
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" style="cursor: pointer;">
                  <el-avatar size="medium" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                  <!-- <img class="heard_top_right_img" src="../assets/192x192.png" alt=""> -->
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="editor">维护</el-dropdown-item>
                  <el-dropdown-item command="password">密码</el-dropdown-item>
                  <!-- <el-dropdown-item command="logout">退出</el-dropdown-item> -->
                </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
    </el-header>
      <el-main class="main-height">
        <div style="padding-left: 16.66667%;background-color: #026abe;">
          <el-menu :default-active="activeTab" background-color="#026abe" active-text-color="#ffd04b" text-color="#fff" @select="handleMenuClick" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="invoice" v-if="unitAdmin">发票审核</el-menu-item>
            <el-menu-item index="user" v-if="unitAdmin">发票台账</el-menu-item>
            <el-menu-item index="config" v-if="unitAdmin">单位配置</el-menu-item>
            <el-menu-item index="applicationStore" v-if="unitAdmin">应用商店</el-menu-item>
            <el-menu-item index="explorer" v-if="unitAdmin">应用资源管理</el-menu-item>
            <el-menu-item index="system" v-if="systemAdmin">系统配置</el-menu-item>
            <el-menu-item index="renew"  v-if="systemAdmin">续费管理</el-menu-item>
          </el-menu>
        </div>
        <personal v-if="unitAdmin && activeTab == 'user'"></personal>
        <invoice-ledger v-if="unitAdmin && activeTab == 'invoice'"></invoice-ledger>
        <configure v-if="unitAdmin && activeTab == 'config'"></configure>
        <system-configure v-if="systemAdmin && activeTab == 'system'"></system-configure>
        <renew-config v-if="activeTab == 'renew' && systemAdmin"></renew-config>
        <application-store v-if="unitAdmin && activeTab == 'applicationStore'"></application-store>
        <explorer-store v-if="unitAdmin && activeTab == 'explorer'"></explorer-store>
      </el-main>

      <!-- 维护个人信息 -->
      <account-dialog :dialogVisible="showAccountDialog" @close="handleCloseDialog"></account-dialog>

  </el-container>
</template>

<script>
import { logout,isSystemAdmin,isUnitAdmin,resetSystemAccountPassword } from '@/api/account';
import { getInfo,storeAccountInfo } from "@/cookie";
import Personal from './components/Personal.vue';
import Configure from './components/Configure.vue';
import InvoiceLedger from './components/InvoiceLedger.vue';
import SystemConfigure from './components/SystemConfigure.vue';
import renewConfig from './components/renewConfig.vue';
import explorerStore from './components/explorerStore.vue';
import applicationStore from './components/applicationStore.vue';
import AccountDialog from './components/dialog/AccountDialog.vue';
import { Message,MessageBox } from 'element-ui';

export default {
  components: { Personal,Configure,InvoiceLedger,SystemConfigure,AccountDialog,renewConfig,applicationStore,explorerStore },
  data() {
    return {
        currentDate: this.getCurrentDate(),
        user:{},
        activeTab : 'invoice',
        systemAdmin: false,
        unitAdmin: false,
        showAccountDialog: false,
    };
  },
  created(){
    this.init();
  },
  mounted(){
    this.user = JSON.parse(localStorage.getItem('USERINFO'));
  },
  methods : {
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1
      const day = now.getDate();
      return `${year}年${month}月${day}日`;
    },
    init(){
      isSystemAdmin().then(res => {
        if(res.code = 200){
          this.systemAdmin = res.data;
          if(this.systemAdmin){
            this.activeTab='system'
          }
        }
      });
      isUnitAdmin().then(res => {
        if(res.code = 200){
          this.unitAdmin = res.data;
          if(this.unitAdmin){
            this.activeTab='invoice'
          }
        }
      });
    },

    //切换
    handleCommand(command) {
        if(command == 'editor'){
           this.showAccountDialog = true; 
        }
        if(command == 'password'){
          this.resetPassword();
        }
        if(command == 'logout'){
           this.logoutExec(); 
        }
    },
    logoutExec(){
      logout(); 
    },
    //菜单切换
    handleMenuClick(val){
      // console.log("ssssssssss",val)
      this.activeTab = val;
    },

    handleCloseDialog(){
      this.showAccountDialog = false;
    },

    //重置密码
    resetPassword(){
      let info_ = getInfo();
      let id = info_.uid;
      MessageBox.prompt('请输入新密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator:(val) => {
              if(val == '' || val == null){
                  return '密码不能为空';
              }
          }
      }).then(({ value }) => {
        resetSystemAccountPassword({id:id,password:value}).then(res => {
            if(res.code == 200){
               Message.success("操作成功"); 
            } else {
               Message.success(res.msg); 
            }
        });
      }).catch(() => {
               
      });
    },

  }
};
</script>

<style scoped>
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-menu-demo{
  font-size: 18px;
}
 .router-link-exact-active .el-menu-item,
 .el-menu-item.is-active,
 .router-link-exact-active .el-sub-menu .el-sub-menu__title,
 .is-active .el-sub-menu__title{
  color: #026abe !important;
  background-color: #fff !important;
  /* font-weight: bold; */
  font-size: 18px !important;
}
 .el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
  color: #fff !important;
  background-color: #fff;
  font-size: 18px !important;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border: none;
}
.el-menu-item:focus, .el-menu-item:hover {
  border: none;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border: none;
}
.el-header {
  /* background-color: #dfe5ec; */
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.font-size-default {
  display: flex;
  justify-content: space-between;
  align-content: center;
  line-height: normal;
  font-size: 15px;
}

.main-height {
  min-height: 850px;
  height: 95%;
  padding: 0;
}
.heard_top{
  height: 80px;
  /* background: pink; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.heard_top_left{
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: rgb(26, 84, 130);
  }
  .heard_top_right {
   display: flex;
   align-items: center;
  }
  .heard_top_right_li{
    margin-right: 40px;
    font-size: 15px;
    color: rgb(26, 84, 130);
  }
  .pointer{
    cursor: pointer;
  }
  .heard_top_right_box{
    width: 50px;
    height: 50px;
    /* margin-right: 10px; */
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: #f3f3f3; */
  }
  .heard_top_right_img{
    width: 70px;
    height: 70px;
  }
</style>




// WEBPACK FOOTER //
// src/views/Home.vue